module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-cover-7-94dff9e5a4ef68477ddd3a460dc65a4f.jpg";